/**
 * Il nome di un sistema esterno come si scrive a schermo.
 *
 * Arriva come chiave tecnica minuscola (`alyante`, `maeway-v8`): scriverla così com'è in mezzo a una
 * frase italiana si legge come un errore di battitura. I nomi noti hanno la loro grafia, gli altri
 * prendono l'iniziale maiuscola invece di essere lasciati grezzi o nascosti — un sistema che non
 * conosciamo va comunque nominato, altrimenti l'avviso dice «un gestionale esterno» a qualcuno che sa
 * benissimo quale.
 *
 * Sta in `shared/lib` perché la leggono anche i messaggi d'errore (`EXTERNAL_SYNC_LOCKED` nomina il
 * sistema), e `shared` non importa da `features`.
 */
const SPELLING: Record<string, string> = {
  alyante: 'Alyante',
  sap: 'SAP',
  zucchetti: 'Zucchetti',
  teamsystem: 'TeamSystem',
  /* Il connettore che porta commesse, attività e persone dal MaeWay v8 (BE-TO-FE-CONNETTORE-MAEWAY-V8-v1). */
  'maeway-v8': 'MaeWay v8',
};

export function systemName(key: string | null): string | null {
  if (!key) return null;
  return SPELLING[key.toLowerCase()] ?? (key.charAt(0).toUpperCase() + key.slice(1));
}
